import React from "react";
// import Fade from "react-reveal/Fade";
// import { HashLink } from "react-router-hash-link";

// assets
import closeButton from "../../assets/images/CLOSE-BUTTON.png";

const Bio = (props) => {
  const {
    srcImg,
    title1,
    title2,
    bio1,
    bio2,
    bio3,
    bio4,
    bio5,
    bio6,
    bio7,
    closeBio,
    hashName,
  } = props;

  // const scrollWithOffset = (el) => {
  //   const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  //   const yOffset = 500;
  //   window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  // };
  return (
    <>
      {/* <Fade duration={200}> */}
      <div className="bio-container" id={hashName}>
        <div className="bio-inner border border-solid border-black">
          <div className="bio-top p-4 flex justify-between p-4">
            <h4 className="text-xl">{title1}</h4>
            <img
              src={closeButton}
              alt="close button"
              className="bio-close-button"
              onClick={closeBio}
            />
          </div>
          <hr />
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_3fr] gap-5 p-4">
            <div className="w-full flex justify-center items-start">
              <img src={srcImg} alt="" />
            </div>
            <div className="bio-desc">
              <p>{bio1}</p>
              <p>{bio2}</p>
              <p>{bio3}</p>
              <p>{bio4}</p>
              <p>{bio5}</p>
              <p>{bio6}</p>
              <p>{bio7}</p>
            </div>
          </div>
          <div className="p-3 border-t flex justify-end">
            <button
              className="inline-block font-normal leading-6 text-white text-center no-underline align-middle cursor-pointer select-none bg-[#c39f5c] border border-[#c39f5c] px-6 py-4 text-sm rounded-none transition-colors transition-shadow transition-border duration-150 ease-in-out uppercase tracking-widest"
              onClick={closeBio}
            >
              Close
            </button>
          </div>
        </div>
      </div>
      {/* </Fade> */}
    </>
  );
};

export default Bio;
